import { createRoute } from "../../utils";

import {
  crawlerManagementRoutesObj,
  crawlerManagementBreadcrumbs,
} from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const crawlerRouteMetadata: IRouteMetadataObj<
  typeof crawlerManagementRoutesObj
> = {
  home: {
    title: "searchPeriodTime",
    lazy: () => import("@/pages/adminPanel/crawler/page"),
    mode: "edit",
    permission: [IRole.SUPER_ADMIN],
  },
};

export const crawlerRoutes = createRoute<typeof crawlerManagementRoutesObj>(
  crawlerManagementRoutesObj,
  crawlerRouteMetadata,
  crawlerManagementBreadcrumbs,
);
